import { render } from "./billingset-types.vue?vue&type=template&id=70d70b71"
import script from "./billingset-types.vue?vue&type=script&lang=js"
export * from "./billingset-types.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__